/* eslint-disable */
import { Injectable } from "@angular/core";
import { APP_CONFIG, ENVIRONMENTS } from '../../../../../../../../app/app.config';
@Injectable({ providedIn: 'root' })
export class AIAgentServiceConfig {
    private _environment: string = APP_CONFIG.ENVIRONMENT;
    constructor() {

    }

    public getEnvironment(): any {
        switch (this._environment) {
            case ENVIRONMENTS.mock:
                return this.configMock;
            case ENVIRONMENTS.dev:
                return this.configProd;
            case ENVIRONMENTS.test:
                return this.configProd;
            case ENVIRONMENTS.stg:
                return this.configProd;
            case ENVIRONMENTS.prod:
                return this.configProd;
            default:
                return null;
        }
    }

    private configMock: any = { // MOCK - local json settings
        environment: ENVIRONMENTS.mock,
        baseUrl: '',
        apiUrl: {
            message: 'api/v1/EVAController/message',
            historyList: '/api/v1/EVAController/GetChatHistories',
            getChatHistory: '/api/v1/EVAController/GetChatHistory',
            getSitesForCorporates: 'CustomerSites',
            getEvaResponse: 'api/v1/Conversational/GetConversationalResponseV2',
            getEvaResponseV2: 'api/v2/Conversational/GetConversationalResponse',
            getFeedback: 'api/v1/Feedback/GetFeedback',
            saveFeedback: 'api/v1/Feedback/SaveFeedback',
            getEvaChatResponse: 'api/v1/EvaDci/Chat',
            getEvaChatSessions: 'api/v1/EvaDci/Sessions',
            getEvaChatResponse2: 'DataCenterAggrService/api/v1/EvaCoolant/Chat',
            getEvaChatSessions2: 'DataCenterAggrService/api/v1/EvaCoolant/Sessions'

        }
    };

    private configProd: any = { // PRODUCTION - PRODUCTION ENVIRONMENT SETTINGS
        environment: ENVIRONMENTS.prod,
        baseUrl: '',
        apiUrl: {
            message: 'api/v1/EVAController/message',
            historyList: '/api/v1/EVAController/GetChatHistories',
            getChatHistory: '/api/v1/EVAController/GetChatHistory',
            getSitesForCorporates: 'CustomerSites',
            getEvaResponse: 'api/v1/Conversational/GetConversationalResponseV2',
            getEvaResponseV2: 'api/v2/Conversational/GetConversationalResponse',
            getFeedback: 'api/v1/Feedback/GetFeedback',
            saveFeedback: 'api/v1/Feedback/SaveFeedback',
            getEvaChatResponse: 'api/v1/EvaDci/Chat',
            getEvaChatSessions: 'api/v1/EvaDci/Sessions',
            getEvaChatResponse2: 'DataCenterAggrService/api/v1/EvaCoolant/Chat',
            getEvaChatSessions2: 'DataCenterAggrService/api/v1/EvaCoolant/Sessions'
        }
    };

    public setEnvironment(environment: string): any {
        this._environment = environment;
    }
}

